function getQueryVariable(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split("&")
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=")
    /* eslint-disable eqeqeq */
    if (pair[0] == variable) {
      /* eslint-enable eqeqeq */
      return pair[1]
    }
  }
  return false
}

export default getQueryVariable
